import { LayoutService } from '../core/services/layout.service'
import { PageService } from '../core/services/page.service'
import { ChatState } from '../core/services/chat.service'
import { Observable, Subscription } from 'rxjs'
import { OnDestroy, OnInit, Directive} from '@angular/core'
import { ActivatedRoute, NavigationStart, Router } from '@angular/router'
import { filter } from 'rxjs/operators'
import { PageNavigationService } from '../core/services/page-navigation.service'
import { NGXLogger } from 'ngx-logger'

@Directive()
export class SitePage implements OnInit, OnDestroy {
  constructor(
    private layoutService: LayoutService,
    private pageData: Observable<any>,
    public page: PageService,
    public chatState: ChatState,
    public router: Router,
    private route: ActivatedRoute,
    public pageNavigationService: PageNavigationService,
    public logger: NGXLogger,
    // public notifier: NotifierService,
  ) {
    this.layoutService
      .subscribeToLayoutChanges()
      .subscribe((observerResponse) => {
        this.breakpoints = this.layoutService.handleLayoutChanges()
      }, (error: any) => {
        console.error(error)
      })
    this.pageData.subscribe((res: any) => {
      this.pageContentData = res.data.attributes
    }, (error: any) => {
      console.error(error)
    })
    this.chatState.observables.chatDisplayState.subscribe((state) => {
      this.showChat = state
    }, (error: any) => {
      console.error(error)
    })

    this.route.queryParams.subscribe(res => {
      if (res?.checkLoanOptions){
        this.showOptionsModal = true
      }
    })

    this.logRouter(router)
  }

  routerSubscription: Subscription = null

  breakpoints: any = {
    extraSmall: false,
    small: false,
    large: true,
    extraLarge: true,
  }
  showChat = false
  showOptionsModal = false
  pageContentData: any = {}

  closeModal() {
    if (this.showOptionsModal) {
      // this.notifier.hideAll()
      this.showOptionsModal = false
    }
  }

  toggleOptionsModal() {
    if(this.breakpoints.large || this.breakpoints.extraLarge){
      this.showOptionsModal = !this.showOptionsModal
    } else {
      this.router.navigate(['/getphonenumber'],{ skipLocationChange: true})
    }
    
  }

  imageMap(imageObj: any): any[] {
    return this.page.imageMap(imageObj)
  }

  getVideoURL(mediaObj: any): string {
    return this.page.getVideoURL(mediaObj)
  }

  ngOnInit() {
    this.page.scrollToElement()
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe()
  }









  logRouter(router: Router) {


    this.routerSubscription = router.events
      .pipe(
        // The "events" stream contains all the navigation events. For this demo,
        // though, we only care about the NavigationStart event as it contains
        // information about what initiated the navigation sequence.
        filter(
          (event: any) => {

            return (event instanceof NavigationStart)

          }
        )
      )
      .subscribe(
        (event: NavigationStart) => {

          /*
          console.group('NavigationStart Event')
          // Every navigation sequence is given a unique ID. Even "popstate"
          // navigations are really just "roll forward" navigations that get
          // a new, unique ID.
          this.logger.info('navigation id:', event.id)
          this.logger.info('route:', event.url)
          // The "navigationTrigger" will be one of:
          // --
          // - imperative (ie, user clicked a link).
          // - popstate (ie, browser controlled change such as Back button).
          // - hashchange
          // --
          // NOTE: I am not sure what triggers the "hashchange" type.
          this.logger.info('trigger:', event.navigationTrigger)

          // This "restoredState" property is defined when the navigation
          // event is triggered by a "popstate" event (ex, back / forward
          // buttons). It will contain the ID of the earlier navigation event
          // to which the browser is returning.
          // --
          // CAUTION: This ID may not be part of the current page rendering.
          // This value is pulled out of the browser; and, may exist across
          // page refreshes.
          */
          if (event.restoredState) {

            console.warn(
              'restoring navigation id:',
              event.restoredState.navigationId
            )

          }


          console.groupEnd()
          // save new navigation info
          this.pageNavigationService.writeNewState(event.id, event.url, event.navigationTrigger)
          this.pageNavigationService.openNow = true
          this.pageNavigationService.modalRestore = true
        }
      )
  }

}
